export var CheckboxDefaultProps = {
    label: "",
    name: "",
    value: "",
    disabled: false,
    texteAide: undefined,
    taille: 'md',
    required: false
};
